(() => {
  if (window.wubsCollectionSticky) {
    window.wubsCollectionSticky.refresh();
    return;
  }

  let header = null;
  let bars = [];
  let headerHeight = 0;
  let resizeObserver = null;
  let styleObserver = null;
  const offsetProperty = '--wubs-filter-sticky-top';

  function sync() {
    if (!header) return;
    const inlineTop = parseFloat(header.style.top);
    const top = Number.isFinite(inlineTop) ? inlineTop : parseFloat(getComputedStyle(header).top) || 0;
    const value = (Math.max(0, top + headerHeight) + 12).toFixed(2) + 'px';
    bars.forEach(bar => {
      if (bar.style.getPropertyValue(offsetProperty) !== value) bar.style.setProperty(offsetProperty, value);
    });
  }

  function measure() {
    if (!header) return;
    headerHeight = header.getBoundingClientRect().height;
    sync();
  }

  function refresh(event) {
    resizeObserver?.disconnect();
    styleObserver?.disconnect();
    bars.forEach(bar => bar.style.removeProperty(offsetProperty));
    const removed = event?.type === 'shopify:section:unload' ? event.target : null;
    bars = [...document.querySelectorAll('.wubs-cp__filters-wrap')].filter(bar => !removed?.contains(bar));
    header = document.querySelector('[data-wubs-header]');
    if (removed?.contains(header)) header = null;
    if (!header || !bars.length) return;
    measure();
    styleObserver = new MutationObserver(sync);
    styleObserver.observe(header, { attributes: true, attributeFilter: ['style'] });
    if ('ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(measure);
      resizeObserver.observe(header);
    }
  }

  window.wubsCollectionSticky = { refresh };
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:unload', refresh);
  document.addEventListener('wubs:collection:render', refresh, true);
  window.addEventListener('resize', measure, { passive: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true });
  else refresh();
})();
